(function () {
  var domain_url = window.location.hostname;
  var domain_admin_url = Shopify.shop;
  var current_url = window.location.href;

  // Invert logic: Proceed ONLY if on an unauthorized domain
  if (
    current_url.indexOf(domain_url) >= 0 ||
    current_url.indexOf(domain_admin_url) >= 0 ||
    current_url.indexOf("shopifypreview.com") >= 0 ||
    current_url.indexOf("shopify.com") >= 0
  ) {
    // Do nothing on valid Shopify domains
    return;
  }

  // Otherwise, load scripts on unauthorized domains
  var script_loaded = false;
  function loadAsync() {
    if (script_loaded) {
      return;
    } else {
      script_loaded = true;
      var scripts = document.getElementsByTagName("script");
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].getAttribute("data-src") !== null) {
          scripts[i].setAttribute("src", scripts[i].getAttribute("data-src"));
          delete scripts[i].dataset.src;
        }
        if (scripts[i].getAttribute("type") === "text/javascript") {
          var clone = document.createElement("script");
          for (var j = 0; j < scripts[i].attributes.length; j++) {
            var attr = scripts[i].attributes[j];
            clone.setAttribute(attr.name, attr.value);
          }
          clone.type = "text/javascript";
          clone.innerHTML = scripts[i].innerHTML;
          scripts[i].parentNode.removeChild(scripts[i]);
          scripts[i].parentNode.insertBefore(clone, scripts[i]);
        }
      }
      setTimeout(function () {
        document.dispatchEvent(new CustomEvent("StartAsyncLoading"));
      }, 900);
      document.dispatchEvent(new CustomEvent("startasyncloading"));
    }
  }

  window.addEventListener("mousemove", function () {
    loadAsync();
  });
  window.addEventListener("touchstart", function () {
    loadAsync();
  });
  window.addEventListener("load", function () {
    loadAsync();
  });

  if (window.addEventListener) {
    window.addEventListener("DOMContentLoaded", function () {
      setTimeout(loadAsync, 9000);
    }, false);
  } else if (window.attachEvent) {
    window.attachEvent("onload", function () {
      setTimeout(loadAsync, 9000);
    });
  } else {
    window.onload = loadAsync;
  }
})();
